import * as React from 'react'
import './OverView.scss'
import { Grid } from '@material-ui/core'
import { FormattedMessage } from "react-intl";
import { countListType } from "../../reducers/types";


interface IProps {
  tradeNum: number,
  tradeAmt: number,
  tradeAmtMonth?: number,
  tradeNumMonth?: number,
  currency?: string,
  countList?: countListType[]
}

class OverView extends React.Component<IProps, {}> {
  public render() {
    let { tradeNum, tradeAmt, tradeAmtMonth, tradeNumMonth, currency, countList } = this.props
    return (
      <div className="overView" style={{ height: '38%', overflowX: 'hidden', overflowY: 'auto' }}>
        {countList?.map((item, index) => (
          <Grid container spacing={2} key={index}>
            <Grid item xs={3}>
              <div className="todayCnt overViewItem">
                <span className="icon icon-today"></span>
                <div className="overview-content">
                  <span className="title"><FormattedMessage id="todayIncome" /></span>
                  <span className="value">{item.currency || ''} {item.currentDayTradeAmt}</span>
                </div>
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className="todayAmt overViewItem">
                <span className="icon icon-today"></span>
                <div className="overview-content">
                  <span className="title"><FormattedMessage id="todayTrans" /></span>
                  <span className="value">{item.currency || ''}  {item.currentDayTradeNum || 0}</span>
                </div>
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className="monthlyCnt overViewItem">
                <span className="icon icon-month"></span>
                <div className="overview-content">
                  <span className="title"><FormattedMessage id="monthlyIncome" /></span>
                  <span className="value">{item.currency || ''}  {item.currentMonthTradeAmt || 0}</span>
                </div>
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className="monthlyAmt overViewItem">
                <span className="icon icon-month"></span>
                <div className="overview-content">
                  <span className="title"><FormattedMessage id="monthlyTradeNum" /></span>
                  <span className="value">{item.currency || ''}  {item.currentMonthTradeNum || 0}</span>
                </div>
              </div>
            </Grid>
          </Grid>
        ))}
      </div>

    );
  }
}

export default OverView